export default __webpack_public_path__ + "static/media/close-circle-outline.6ab6c95f.svg";